import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { getSpecificEnumData } from "../../redux/slices/enumSlice";
import { setEnumData } from "../../redux/slices/enumSlice";
import { useGetEnumDataMutation } from "../../redux/services/enumApi";
import { useSaveServiceProviderDetailMutation } from "../../redux/services/serviceProviderApi";
import Header from "../../components/Header/Header";
import MuiAlert from "../MuiAlert/MuiAlert";
import { FaFacebook, FaInstagram, FaTiktok, FaTwitter } from "react-icons/fa";
import { BsTelephone } from "react-icons/bs";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { TiMail } from "react-icons/ti";
import Loading from "../commons/Loading";
import { last4Character, tagManager } from "../../redux/services/utility";
import Footer from "../../components/Footer/Footer";
import business from "../../assets/business.svg";
import customer from "../../assets/customer.svg";
import revenue from "../../assets/revenue.svg";

type Props = {};

const ServiceProviderSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .matches(/^[a-zA-Z\s.-]+$/, { message: "Name must be alphabetic" })
    .trim(),
  contactNumber: Yup.string()
    .required("Contact number is required")
    .matches(
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      "Phone number is not valid"
    )
    .min(10, "Contact Number must be 10 digits")
    .max(10, "Contact Number must be 10 digits")
    .trim(),
  emailId: Yup.string().email().required("Email is required").trim(),
  businessName: Yup.string()
    .required("Business Name is required")
    .matches(/^[a-zA-Z\s.-]+$/, { message: "Business Name must be alphabetic" })
    .trim(),
});

const BecomeAPartner = (props: Props) => {
  const dispatch: any = useAppDispatch();
  const navigate = useNavigate();
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const userToken: string = currentUser?.jwtToken;
  let enumData: any = useAppSelector(getSpecificEnumData);
  const [checkData, setcheckData] = useState([]);
  const [getEnumData, enumResponse] = useGetEnumDataMutation();
  const [saveServiceProviderDetail, saveResponse] =
    useSaveServiceProviderDetailMutation();
  const [statusCode, setStatusCode] = useState({ type: "", code: "" }) as any;
  const [isAlertVisible, setIsAlertVisible] = useState(false);

  useEffect(() => {
    getEnumData({ token: userToken });
  }, []);

  useEffect(() => {
    if (enumResponse.isSuccess) {
      dispatch(setEnumData(enumResponse.data));
    }
  }, [enumResponse.isSuccess]);

  useEffect(() => {
    if (enumData) {
      setcheckData(enumData["COMPANY_TYPE"]);
    }
  }, [enumData]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (enumResponse.isSuccess) {
      dispatch(setEnumData(enumResponse.data));
    }
  }, [enumResponse.isSuccess]);

  useEffect(() => {
    if (saveResponse.isSuccess) {
      setStatusCode({ type: "success", code: "PARTNER_SUCCESSFUL" });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
    if (saveResponse.isError) {
      const errorCode: any = saveResponse.error;
      setStatusCode({
        type: "error",
        code: errorCode.data.serviceErrors[0]?.errorCode,
      });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
  }, [saveResponse.isSuccess, saveResponse.isError]);

  const [formValues, setFormValues] = useState({
    name: "",
    contactNumber: "",
    emailId: "",
    businessName: "",
    exemptPayeeCode: "",
    exemptionFromFATCAReportingCode: "",
    address: "",
    city: "",
    state: "",
    country: "",
    ZIPCode: "",
    listAccountNumber: "",
    socialSecurityNumber: "",
    employerIdentificationNumber: "",
    taxClassification: "",
    other: "",
    companyTypeList: "",
  });

  const saveServiceProviderDataToServer = async (values: any, action: any) => {
    tagManager('Partner_With_Spotfinder', values)
    await saveServiceProviderDetail({
      payload: {
        address: values.address,
        businessName: values.businessName.trim(),
        city: values.city.trim(),
        commission: "",
        companyTypeList: values.companyTypeList,
        contactNumber: values.contactNumber,
        country: values.country.trim(),
        einNumber: values.employerIdentificationNumber,
        emailId: values.emailId.trim(),
        exemptFatca: 0,
        filePath: "",
        gstNo: "",
        llcTaxType: values.taxClassification,
        name: values.name.trim(),
        other: values.other,
        password: "",
        payeeCode: 0,
        listAccountNumber: values.primaryAccountNo,
        socialSecNumber: values.socialSecurityNumber,
        state: values.state.trim(),
        status: values.status,
        tierType: "",
        vatNo: "",
        zip: values.ZIPCode,
        requestFrom: "PWA",
        vendorAlias:
          values.businessName + "-" + last4Character(values.contactNumber),
      },
      token: userToken,
    });
    action.resetForm();
  };

  return (
    <div>
        <div className="md:p-10 p-2">
        <div className="h-[75px] mx-10">
            <Header position={"fixed"} isLoggedIn={userToken ? true : false} />
        </div>

        <div
            className="md:ml-10"
            style={{
            backgroundImage: `url(${require("../../assets/partner.png")})`,
            backgroundSize: "210vh",
            height: "440px",
            borderRadius: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            backgroundRepeat: "no-repeat",
            boxShadow: "inset 0 0 0 100vmax rgba(0,0,0,.5)",
            }}
        >
            <h1 className="text-center text-[40px] lg:text-[64px] text-white font-medium px-2">
            Partner With CarRental
            </h1>
            <div className="mt-3">
            <p className="text-center text-[20px] lg:text-[24px] text-white px-2">
                Grow your business by listing your service with us
            </p>
            </div>
        </div>

        <div className="text-center text-[20px] md:text-[30px] lg:text-[40px] mt-8 text-gray-700">
            Benefits When You Partner With CarRental
        </div>
        <p className="text-center text-[15px] md:text-[20px] md:mx-10 lg:mx-20 text-gray-500 mt-2">
            We understand the pain for finding the right ride. 
            Handicap friendly rides, diligent customer support, we aim to
            comfort you with nearest rides!
        </p>
        <div className="flex flex-col md:flex-row justify-center items-center">
            <div className="w-[300px] lg:h-[200px] h-[210px] bg-[#F9F4EF] flex flex-col drop-shadow-md mt-6 md:ml-4 rounded-2xl">
            <img
                className="lg:ml-24 md:ml-12 ml-24 mt-8 w-28 h-28"
                src={business}
                alt=""
            />
            <p className="text-center mt-2 mb-2">Grow your Business</p>
            </div>

            <div className="w-[300px] lg:h-[200px] h-[210px] bg-[#F9F4EF] flex flex-col drop-shadow-md mt-6 md:ml-4 rounded-2xl px-2">
            <img
                className="lg:ml-24 md:ml-12 ml-24 mt-8 w-28 h-28"
                src={customer}
                alt=""
            />
            <p className="text-center mt-2 mb-2">Get Great New Customers</p>
            </div>

            <div className="w-[300px] lg:h-[200px] h-[210px] bg-[#F9F4EF] flex flex-col drop-shadow-md mt-6 md:ml-4 rounded-2xl">
            <img
                className="lg:ml-24 md:ml-12 ml-24  mt-8 w-28 h-28"
                src={revenue}
                alt=""
            />
            <p className="text-center mt-2 mb-2">Increase Revenue</p>
            </div>
        </div>
        <div className="flex justify-center">
            <div className="md:w-[80%] w-full drop-shadow-md rounded-2xl mb-4 mt-8">
            {isAlertVisible && (
                <div>
                <MuiAlert
                    severity={statusCode?.type!}
                    messageType={statusCode?.code!}
                />
                </div>
            )}
            <div className="w-full">
                <Formik
                enableReinitialize
                initialValues={formValues}
                onSubmit={saveServiceProviderDataToServer}
                validationSchema={ServiceProviderSchema}
                >
                {({
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    values,
                    touched,
                    errors,
                }) => (
                    <div
                    style={{
                        paddingTop: "2rem",
                        paddingBottom: "2rem",
                    }}
                    >
                    <div className="text-center text-[25px]">
                        Become a Partner
                    </div>
                    <Box
                        className="w-full flex-col md:flex-row"
                        display={"flex"}
                        alignItems={"center"}
                        marginTop={"25px"}
                    >
                        <Box className="w-full md:w-[50%]">
                        <Stack direction="column" alignItems="self-start">
                            <p>
                            Name
                            </p>
                            <TextField
                            className="w-full"
                            color="error"
                            variant="outlined"
                            autoComplete="name"
                            type="text"
                            id={"name"}
                            placeholder="Enter Name"
                            name={"name"}
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={Boolean(touched.name && errors.name)}
                            helperText={touched.name && errors.name}
                            sx={{
                                backgroundColor: "#E2E2E2",
                                borderRadius: "30px",
                                mb: 2,
                                height: "45px", // Slightly reduced height for a compact look
                                "& .MuiInputBase-root": {
                                display: "flex",
                                alignItems: "center", // Centers input text vertically
                                height: "100%",
                                padding: "0 12px", // Reducing padding inside input container
                                },
                                "& .MuiOutlinedInput-root": {
                                borderRadius: "30px",
                                height: "100%",
                                "& input": {
                                    padding: "6px 8px", // Reduced padding inside input field
                                },
                                "& fieldset": { borderColor: "transparent" },
                                "&:hover fieldset": { borderColor: "transparent" },
                                "&.Mui-focused fieldset": { borderColor: "transparent" },
                                },
                                "& .MuiInputLabel-root": {
                                top: "50%",
                                left: "12px", // Moves label closer to start
                                transform: "translateY(-50%)", // Centers label vertically
                                },
                                "& .MuiInputLabel-shrink": {
                                top: 6, // Moves label up when focused
                                transform: "translateY(-100%) scale(0.75)",
                                },
                                "& .MuiFormHelperText-root": {
                                position: "absolute",
                                bottom: "-18px", // Adjusted for better spacing
                                fontSize: "12px",
                                color: "red",
                                },
                            }}
                            />
                        </Stack>
                        </Box>
                        <Box className="ml-2 w-full md:w-[50%]">
                        <Stack direction="column" alignItems="self-start">
                            <p>
                            Business Name
                            </p>
                            <TextField
                            placeholder="Enter Business Name"
                            name={"businessName"}
                            className="w-full"
                            color="error"
                            value={values.businessName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={Boolean(
                                touched.businessName && errors.businessName
                            )}
                            helperText={
                                touched.businessName && errors.businessName
                            }
                            sx={{
                                backgroundColor: "#E2E2E2",
                                borderRadius: "30px",
                                mb: 2,
                                height: "45px", // Slightly reduced height for a compact look
                                "& .MuiInputBase-root": {
                                display: "flex",
                                alignItems: "center", // Centers input text vertically
                                height: "100%",
                                padding: "0 12px", // Reducing padding inside input container
                                },
                                "& .MuiOutlinedInput-root": {
                                borderRadius: "30px",
                                height: "100%",
                                "& input": {
                                    padding: "6px 8px", // Reduced padding inside input field
                                },
                                "& fieldset": { borderColor: "transparent" },
                                "&:hover fieldset": { borderColor: "transparent" },
                                "&.Mui-focused fieldset": { borderColor: "transparent" },
                                },
                                "& .MuiInputLabel-root": {
                                top: "50%",
                                left: "12px", // Moves label closer to start
                                transform: "translateY(-50%)", // Centers label vertically
                                },
                                "& .MuiInputLabel-shrink": {
                                top: 6, // Moves label up when focused
                                transform: "translateY(-100%) scale(0.75)",
                                },
                                "& .MuiFormHelperText-root": {
                                position: "absolute",
                                bottom: "-18px", // Adjusted for better spacing
                                fontSize: "12px",
                                color: "red",
                                },
                            }}
                            />
                        </Stack>
                        </Box>
                    </Box>

                    <Box
                        className="flex-col md:flex-row"
                        display={"flex"}
                        alignItems={"center"}
                        marginTop={"25px"}
                    >
                        <Box className="w-full md:w-[50%]">
                        <Stack direction="column" alignItems="self-start">
                            <p>
                            Contact Number
                            </p>
                            <TextField
                            placeholder="Enter Contact Number"
                            name={"contactNumber"}
                            className="w-full"
                            value={values.contactNumber}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            color="error"
                            error={Boolean(
                                touched.contactNumber && errors.contactNumber
                            )}
                            helperText={
                                touched.contactNumber && errors.contactNumber
                            }
                            sx={{
                                backgroundColor: "#E2E2E2",
                                borderRadius: "30px",
                                mb: 2,
                                height: "45px", // Slightly reduced height for a compact look
                                "& .MuiInputBase-root": {
                                display: "flex",
                                alignItems: "center", // Centers input text vertically
                                height: "100%",
                                padding: "0 12px", // Reducing padding inside input container
                                },
                                "& .MuiOutlinedInput-root": {
                                borderRadius: "30px",
                                height: "100%",
                                "& input": {
                                    padding: "6px 8px", // Reduced padding inside input field
                                },
                                "& fieldset": { borderColor: "transparent" },
                                "&:hover fieldset": { borderColor: "transparent" },
                                "&.Mui-focused fieldset": { borderColor: "transparent" },
                                },
                                "& .MuiInputLabel-root": {
                                top: "50%",
                                left: "12px", // Moves label closer to start
                                transform: "translateY(-50%)", // Centers label vertically
                                },
                                "& .MuiInputLabel-shrink": {
                                top: 6, // Moves label up when focused
                                transform: "translateY(-100%) scale(0.75)",
                                },
                                "& .MuiFormHelperText-root": {
                                position: "absolute",
                                bottom: "-18px", // Adjusted for better spacing
                                fontSize: "12px",
                                color: "red",
                                },
                            }}
                            />
                        </Stack>
                        </Box>
                        <Box className="ml-2 w-full md:w-[50%]">
                        <Stack direction="column" alignItems="self-start">
                            <p>
                            Email ID
                            </p>
                            <TextField
                            placeholder="Enter Email"
                            name={"emailId"}
                            className="w-full"
                            value={values.emailId}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            color="error"
                            sx={{
                                backgroundColor: "#E2E2E2",
                                borderRadius: "30px",
                                mb: 2,
                                height: "45px", // Slightly reduced height for a compact look
                                "& .MuiInputBase-root": {
                                display: "flex",
                                alignItems: "center", // Centers input text vertically
                                height: "100%",
                                padding: "0 12px", // Reducing padding inside input container
                                },
                                "& .MuiOutlinedInput-root": {
                                borderRadius: "30px",
                                height: "100%",
                                "& input": {
                                    padding: "6px 8px", // Reduced padding inside input field
                                },
                                "& fieldset": { borderColor: "transparent" },
                                "&:hover fieldset": { borderColor: "transparent" },
                                "&.Mui-focused fieldset": { borderColor: "transparent" },
                                },
                                "& .MuiInputLabel-root": {
                                top: "50%",
                                left: "12px", // Moves label closer to start
                                transform: "translateY(-50%)", // Centers label vertically
                                },
                                "& .MuiInputLabel-shrink": {
                                top: 6, // Moves label up when focused
                                transform: "translateY(-100%) scale(0.75)",
                                },
                                "& .MuiFormHelperText-root": {
                                position: "absolute",
                                bottom: "-18px", // Adjusted for better spacing
                                fontSize: "12px",
                                color: "red",
                                },
                            }}
                            error={Boolean(touched.emailId && errors.emailId)}
                            helperText={touched.emailId && errors.emailId}
                            />
                        </Stack>
                        </Box>
                    </Box>
                    <div
                        className="w-full flex justify-center md:justify-end mt-5 md:mr-[100px]"
                    >
                        <button
                        className="bg-[#ED1C24] text-white px-6 py-2 mr-5 rounded-full hover:bg-[#ED1C24]"
                        onClick={() => {
                            navigate("/");
                        }}
                        >
                        Cancel
                        </button>
                        <button
                        className="bg-[#ED1C24] text-white px-6 py-2 rounded-full hover:bg-[#ED1C24]"
                        onClick={() => {
                            handleSubmit();
                        }}
                        >
                        Send Request
                        </button>
                    </div>
                    </div>
                )}
                </Formik>
            </div>
            </div>
        </div>
        {enumResponse.isLoading || saveResponse.isLoading ? <Loading /> : null}
        </div>
        <Footer />
    </div>
  );
};

export default BecomeAPartner;
